import React from 'react';
import {Route, Switch} from 'react-router';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import {basename} from 'path';
import {fromKebabCase, toTitleCase} from 'Shared/utilities/stringFormatHelpers';

const ROOT_URI = '/legal';

export const LegalDocumentationRoutesConstants = {
  LEGAL_AGREEMENTS: `${ROOT_URI}`,
  LEGAL_DOCUMENT: (docId: string) => `${ROOT_URI}/${docId}`,
};

type TermsAndConditionsProps = {
  url: string;
};

export default (props: TermsAndConditionsProps) => {
  return (
    <Route
      render={() => {
        return (
          <Switch>
            <Route
              path={LegalDocumentationRoutesConstants.LEGAL_AGREEMENTS}
              render={() => <RoutesUnderLegalAgreements url={props.url} />}
            />
          </Switch>
        );
      }}
    />
  );
};

const RoutesUnderLegalAgreements = (props: TermsAndConditionsProps) => {
  useBreadcrumbs('Legal Agreements', LegalDocumentationRoutesConstants.LEGAL_AGREEMENTS);

  return (
    <Switch>
      <Route path={LegalDocumentationRoutesConstants.LEGAL_AGREEMENTS} render={() => <></>} exact />
      <Route path={props.url} render={() => <RoutesUnderLegalDocument url={props.url} />} exact />
    </Switch>
  );
};

const RoutesUnderLegalDocument = (props: TermsAndConditionsProps) => {
  let title = toTitleCase(fromKebabCase(basename(props.url)));

  const hipaa = 'Hipaa';
  const newYork = "New York";

  if (title.includes(hipaa)) {
    title = title.replace(new RegExp(`${hipaa}`, "i"), hipaa.toUpperCase());
  }

  if (title.includes(newYork))
  {
    title = title.replace(new RegExp(`${newYork}`, "i"), `(${newYork})`);
  }

  useBreadcrumbs(title, props.url);

  return (
    <Switch>
      <Route path={props.url} exact />
    </Switch>
  );
};
